package kangaroorewards.appsdk.core.network.base

/**
 * FormField class used to build form requests
 */
data class FormField(
    val name: String,
    val value: Any?
)